export default __webpack_public_path__ + "static/media/icon_greater_than_lrg.5d8b4281.svg";